import { useEffect, useRef } from "react";

/**
 * useTransformToRef - Transforma uma variável normal
 * em uma ref, mantendo ela atualizada
 * @param toRef valor que será vigiado e armazenado no ref
 * @return ref (que é sempre atualizado) do valor toRef
 */
export function useTransformToRef<T>(toRef: T) {
    const ref = useRef(toRef);

    useEffect(() => {
        ref.current = toRef;
    }, [toRef]);

    return ref;
}
